import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import './search-drawer.scss';
import searchIcon from '../../assets/original-amb-search-icon.png';


const SearchDrawerComponent = () => {
    const {t} = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    const handleSearch = (e: any) => {
        if (e.key === 'Enter' || e.type === 'click') {
            // eslint-disable-next-line max-len
            const searchUrl = `https://www.amb.cat/web/cercador/cercador/-/gcs/f5zOH5pHoY1D/search/default?_GCSRESTPortlet_WAR_RESTportlet_INSTANCE_f5zOH5pHoY1D_retFormat=list&_GCSRESTPortlet_WAR_RESTportlet_INSTANCE_f5zOH5pHoY1D_pageNum=1&_GCSRESTPortlet_WAR_RESTportlet_INSTANCE_f5zOH5pHoY1D_query=${searchTerm}&g-recaptcha-response-action=cercador_general_amb`;
            window.open(searchUrl, '_blank');
        }
    };
    return (
        <div className="search-drawer">
            <input
                type="text"
                className="search-drawer-input"
                placeholder={t('searchPlaceholder')}
                value={searchTerm}
                onChange={handleInputChange}
                onKeyDown={handleSearch}
            />
            <div
                role="button"
                tabIndex={0}
                onClick={handleSearch}
                onKeyDown={handleSearch}
            >
                <img
                    src={searchIcon}
                    alt="Icon"
                    className="search-drawer-icon"
                />
            </div>
        </div>
    );
};

export default SearchDrawerComponent;
